"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const _1 = require(".");
// Define our map of matrix types to icons
const MatrixResourceMap = {
    audio_file: _1.Audio,
    excel_doc: _1.Excel,
    folder: _1.Folder,
    generic_file: _1.GenericFile,
    image: _1.Image,
    page_content: _1.PageContent,
    page_standard: _1.Page,
    pdf_file: _1.Pdf,
    powerpoint_doc: _1.Powerpoint,
    site: _1.Site,
    video_file: _1.Video,
    word_doc: _1.Word,
};
// Export our map
exports.default = MatrixResourceMap;
